"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("./../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function FunctionalComparison(props) {
  var _a = props.flexTitle,
    flexTitle = _a === void 0 ? '' : _a,
    _b = props.desc,
    desc = _b === void 0 ? '' : _b,
    _c = props.configuration,
    configuration = _c === void 0 ? {} : _c,
    _d = props.pcBigBg,
    pcBigBg = _d === void 0 ? '' : _d,
    _e = props.classifyOneIcon,
    classifyOneIcon = _e === void 0 ? '' : _e,
    _f = props.classifyOneBg,
    classifyOneBg = _f === void 0 ? '' : _f,
    _g = props.classifyTwoIcon,
    classifyTwoIcon = _g === void 0 ? '' : _g,
    _h = props.classifyTwoBg,
    classifyTwoBg = _h === void 0 ? '' : _h;
  var pcBigBgFormat = (0, _utils.fomateFileData)(pcBigBg).url;
  var _j = (0, _utils.fomateFileData)(classifyOneIcon),
    classifyOneIconFormat = _j.url,
    classifyOneIconAlt = _j.alt;
  var classifyOneBgFormat = (0, _utils.fomateFileData)(classifyOneBg).url;
  var _k = (0, _utils.fomateFileData)(classifyTwoIcon),
    classifyTwoIconFormat = _k.url,
    classifyTwoIconAlt = _k.alt;
  var classifyTwoBgFormat = (0, _utils.fomateFileData)(classifyTwoBg).url;
  var _l = configuration.prodLTitlePc,
    prodLTitlePc = _l === void 0 ? '' : _l,
    _m = configuration.prodCTitlePc,
    prodCTitlePc = _m === void 0 ? '' : _m,
    _o = configuration.prodCompareType,
    leftData = _o === void 0 ? [] : _o,
    _p = configuration.prod1Desc,
    middleData = _p === void 0 ? [] : _p,
    _q = configuration.prod2Desc,
    rightData = _q === void 0 ? [] : _q;
  var pcData = [leftData, middleData, rightData]; // pc 使用的展示数据
  var pcDataLoopNum = Math.min(leftData.length, middleData.length, rightData.length); // pc 端 loop 数
  var pcListItem = [];
  for (var i = 0; i < pcDataLoopNum; i++) {
    pcListItem.push(/*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-functional-comparison__container__box__list__item"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-functional-comparison__container__box__list__item__left"
    }, /*#__PURE__*/_react["default"].createElement("p", null, pcData[0][i])), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-functional-comparison__container__box__list__item__middle"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
      fill: "#006EFF"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 11.5L6.85352 12.5068L10.9374 16.8462L20 8L19 7L11 13.5L8 11.5Z",
      fill: "#006EFF"
    })), /*#__PURE__*/_react["default"].createElement("p", null, pcData[1][i]))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-functional-comparison__container__box__list__item__right"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("circle", {
      cx: "10",
      cy: "10",
      r: "6",
      fill: "black",
      fillOpacity: "0.3"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
      fill: "black",
      fillOpacity: "0.3"
    })), /*#__PURE__*/_react["default"].createElement("p", null, pcData[2][i])))));
  }
  var _r = (0, _react.useState)(0),
    activeIndex = _r[0],
    setActiveIndex = _r[1];
  var toggleSetActive = function toggleSetActive(index) {
    // 如果点击的是同一个元素
    if (index === activeIndex) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison",
    style: pcBigBgFormat ? {
      backgroundImage: "url(" + pcBigBgFormat + ")"
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__header"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-functional-comparison__header__title"
  }, flexTitle), /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-functional-comparison__header__desc"
  }, desc)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__mobile__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__mobile__container__list"
  }, leftData.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-functional-comparison__mobile__container__list__item",
      key: index,
      onClick: function onClick() {
        return toggleSetActive(index);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-functional-comparison__mobile__container__list__item__title " + (activeIndex === index ? 'active' : '')
    }, /*#__PURE__*/_react["default"].createElement("p", null, item), /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "12",
      viewBox: "0 0 8 12",
      fill: "none"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.99991 0.292908L0.585693 1.70712L4.87859 6.00001L0.585693 10.2929L1.99991 11.7071L7.70701 6.00001L1.99991 0.292908Z",
      fill: "currentColor"
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-functional-comparison__mobile__container__list__item__content " + (activeIndex === index ? 'active' : '')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-functional-comparison__mobile__container__list__item__content__top"
    }, /*#__PURE__*/_react["default"].createElement("p", null, prodLTitlePc), /*#__PURE__*/_react["default"].createElement("p", null, prodCTitlePc)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-functional-comparison__mobile__container__list__item__content__bottom"
    }, /*#__PURE__*/_react["default"].createElement("div", null, middleData[index]), /*#__PURE__*/_react["default"].createElement("div", null, rightData[index]))));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__container__box"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__container__box__list"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__container__box__list__middle",
    style: {
      height: "calc(100% + 4px)"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__container__box__list__middle__title"
  }, classifyOneIconFormat ? (/*#__PURE__*/_react["default"].createElement("img", {
    src: classifyOneIconFormat,
    alt: classifyOneIconAlt
  })) : (/*#__PURE__*/_react["default"].createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    filter: "url(#filter0_b_233_1842)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8615 25.3407C23.6577 24.2032 25.3423 24.2032 26.1385 25.3407L36.2972 39.8531C37.225 41.1786 36.2767 43 34.6587 43H14.3413C12.7233 43 11.775 41.1786 12.7028 39.8531L22.8615 25.3407Z",
    fill: "url(#paint0_linear_233_1842)"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    filter: "url(#filter1_b_233_1842)"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "2",
    y: "5",
    width: "44",
    height: "30",
    rx: "2",
    fill: "#99C5FF",
    fillOpacity: "0.4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "2.5",
    y: "5.5",
    width: "43",
    height: "29",
    rx: "1.5",
    stroke: "url(#paint1_linear_233_1842)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.3157 17.831L33.5658 16.5816L33.9333 18.4203L27.6832 19.6696L27.3157 17.831Z",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.3154 22.1693L27.6831 20.3307L33.9331 21.5805L33.5654 23.4191L27.3154 22.1693Z",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.25 16.25H27.5L21.25 10L15 16.25H16.25V22.5L15.3575 30H17.2513L17.8763 24.375H24.6237L25.2488 30H27.1425L26.25 22.5V16.25ZM21.25 12.6513L22.9738 14.375H19.5262L21.25 12.6513ZM21.875 21.3988V21.875V22.5H20.625V21.875V21.3988V21.25C20.625 20.905 20.905 20.625 21.25 20.625C21.595 20.625 21.875 20.905 21.875 21.25V21.3988ZM23.75 22.5V21.25C23.75 19.8687 22.6312 18.75 21.25 18.75C19.8688 18.75 18.75 19.8687 18.75 21.25V22.5H18.125V16.25H24.375V22.5H23.75Z",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("filter", {
    id: "filter0_b_233_1842",
    x: "6.90133",
    y: "19.051",
    width: "35.1973",
    height: "29.3855",
    filterUnits: "userSpaceOnUse",
    "colorInterpolation-filters": "sRGB"
  }, /*#__PURE__*/_react["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: "2.71828"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_233_1842"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_233_1842",
    result: "shape"
  })), /*#__PURE__*/_react["default"].createElement("filter", {
    id: "filter1_b_233_1842",
    x: "-3.43656",
    y: "-0.436563",
    width: "54.8731",
    height: "40.8731",
    filterUnits: "userSpaceOnUse",
    "color-interpolationFilters": "sRGB"
  }, /*#__PURE__*/_react["default"].createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: "2.71828"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_233_1842"
  }), /*#__PURE__*/_react["default"].createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_233_1842",
    result: "shape"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint0_linear_233_1842",
    x1: "10.5",
    y1: "43",
    x2: "38.5",
    y2: "43",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#006EFF"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#0052D9"
  })), /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint1_linear_233_1842",
    x1: "68",
    y1: "20",
    x2: "40.0733",
    y2: "-20.9591",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#006EFF",
    stopOpacity: "0.199902"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.404666"
  }))))), /*#__PURE__*/_react["default"].createElement("p", null, prodLTitlePc)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__container__box__list__middle__bg",
    style: classifyOneBgFormat ? {
      backgroundImage: "url(" + classifyOneBgFormat + ")"
    } : {}
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__container__box__list__right"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__container__box__list__right__title"
  }, classifyTwoIconFormat ? (/*#__PURE__*/_react["default"].createElement("img", {
    src: classifyTwoIconFormat,
    alt: classifyTwoIconAlt
  })) : (/*#__PURE__*/_react["default"].createElement("svg", {
    width: "45",
    height: "48",
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8615 20.3407C21.6577 19.2032 23.3423 19.2032 24.1385 20.3407L34.2971 34.8531C35.225 36.1786 34.2767 38 32.6587 38H12.3413C10.7233 38 9.77496 36.1786 10.7028 34.8531L20.8615 20.3407Z",
    fill: "url(#paint0_linear_488_1685)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H42C43.1046 0 44 0.895431 44 2V28C44 29.1046 43.1046 30 42 30H2C0.895431 30 0 29.1046 0 28V2Z",
    fill: "#B4C8E1",
    fillOpacity: "0.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.5 5L30 9.7698V19.3094L24.3284 22.4926C24.2408 23.8912 23.008 25 21.5 25C19.9352 25 18.6667 23.8061 18.6667 22.3333C18.6667 20.8606 19.9352 19.6667 21.5 19.6667C22.0827 19.6667 22.6244 19.8322 23.0748 20.1161L27.2564 17.7698L27.2559 12.6053L21.5037 15.8906L15.7427 12.6347L15.7436 17.7698L17.2543 18.6171C16.4009 19.0351 15.8027 19.8735 15.7478 20.8524L13 19.3094V9.7698L21.5 5ZM21.5 8.0792L17.3265 10.42L21.4963 12.7761L25.6466 10.4067L21.5 8.0792Z",
    fill: "white"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "paint0_linear_488_1685",
    x1: "0",
    y1: "38",
    x2: "44",
    y2: "38",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    stopColor: "#95AECF"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "1",
    stopColor: "#5E759B"
  }))))), /*#__PURE__*/_react["default"].createElement("p", null, prodCTitlePc)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-functional-comparison__container__box__list__right__bg",
    style: classifyTwoBgFormat ? {
      backgroundImage: "url(" + classifyTwoBgFormat + ")"
    } : {}
  })), pcListItem))));
}
FunctionalComparison.displayName = 'TCIFunctionalComparison';
var _default = exports["default"] = FunctionalComparison;